export default __webpack_public_path__ + "static/media/ms_sans_serif_bold.9fbe7124.woff";